import request from '@/services/interceptor.js'


// GET - Recupera tutte le info del profilo (utente + azienda + apiKey)
export const get_dati_utente = () => {
    return request({
        url: '/profilo/info',
        method: 'get',
        loadingBar: true
    })
}

// PUT - Aggiorna username ed email dell'utente
export const aggiorna_dati_utente = (data) => {
    return request({
        url: '/profilo/utente',
        method: 'put',
        data,
        loadingBar: true
    })
}

// PUT - Cambia password
export const cambia_password = (data) => {
    return request({
        url: '/profilo/password',
        method: 'put',
        data,
        loadingBar: true
    })
}

// POST - Rigenera API Key
export const rigenera_api_key = () => {
    return request({
        url: '/profilo/apikey/rigenera',
        method: 'post',
        loadingBar: true
    })
}

// PUT - Abilita o disabilita API Key  ({ attivo: true/false })
export const toggle_api_key = (attivo) => {
    return request({
        url: '/profilo/apikey/toggle?attivo=' + attivo,
        method: 'put',
        loadingBar: true
    })
}